/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EligibilityCheckRequestObject } from './EligibilityCheckRequestObject';
import {
    EligibilityCheckRequestObjectFromJSON,
    EligibilityCheckRequestObjectFromJSONTyped,
    EligibilityCheckRequestObjectToJSON,
} from './EligibilityCheckRequestObject';
import type { EligibilityRoutingReason } from './EligibilityRoutingReason';
import {
    EligibilityRoutingReasonFromJSON,
    EligibilityRoutingReasonFromJSONTyped,
    EligibilityRoutingReasonToJSON,
} from './EligibilityRoutingReason';
import type { ExacareEligibilityResponse } from './ExacareEligibilityResponse';
import {
    ExacareEligibilityResponseFromJSON,
    ExacareEligibilityResponseFromJSONTyped,
    ExacareEligibilityResponseToJSON,
} from './ExacareEligibilityResponse';
import type { StediPayer } from './StediPayer';
import {
    StediPayerFromJSON,
    StediPayerFromJSONTyped,
    StediPayerToJSON,
} from './StediPayer';

/**
 * 
 * @export
 * @interface EligibilityCheck
 */
export interface EligibilityCheck {
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    check_id: string;
    /**
     * 
     * @type {Date}
     * @memberof EligibilityCheck
     */
    date_executed: Date;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    user_name: string;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    lead_id: string;
    /**
     * 
     * @type {EligibilityCheckRequestObject}
     * @memberof EligibilityCheck
     */
    request_object: EligibilityCheckRequestObject;
    /**
     * 
     * @type {ExacareEligibilityResponse}
     * @memberof EligibilityCheck
     */
    eligibility_view_model?: ExacareEligibilityResponse;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    coverage_priority: string;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    provider?: EligibilityCheckProviderEnum;
    /**
     * 
     * @type {EligibilityRoutingReason}
     * @memberof EligibilityCheck
     */
    routing_reason?: EligibilityRoutingReason;
    /**
     * 
     * @type {StediPayer}
     * @memberof EligibilityCheck
     */
    stedi_payer?: StediPayer;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    member_identifier_type?: EligibilityCheckMemberIdentifierTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    report_s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof EligibilityCheck
     */
    pdf_generation_status?: EligibilityCheckPdfGenerationStatusEnum;
}


/**
 * @export
 */
export const EligibilityCheckProviderEnum = {
    Inovalon: 'inovalon',
    Stedi: 'stedi'
} as const;
export type EligibilityCheckProviderEnum = typeof EligibilityCheckProviderEnum[keyof typeof EligibilityCheckProviderEnum];

/**
 * @export
 */
export const EligibilityCheckMemberIdentifierTypeEnum = {
    Mbi: 'MBI',
    Ssn: 'SSN'
} as const;
export type EligibilityCheckMemberIdentifierTypeEnum = typeof EligibilityCheckMemberIdentifierTypeEnum[keyof typeof EligibilityCheckMemberIdentifierTypeEnum];

/**
 * @export
 */
export const EligibilityCheckPdfGenerationStatusEnum = {
    Pending: 'pending',
    Generated: 'generated',
    Failed: 'failed'
} as const;
export type EligibilityCheckPdfGenerationStatusEnum = typeof EligibilityCheckPdfGenerationStatusEnum[keyof typeof EligibilityCheckPdfGenerationStatusEnum];


/**
 * Check if a given object implements the EligibilityCheck interface.
 */
export function instanceOfEligibilityCheck(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "check_id" in value;
    isInstance = isInstance && "date_executed" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "user_name" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "request_object" in value;
    isInstance = isInstance && "coverage_priority" in value;

    return isInstance;
}

export function EligibilityCheckFromJSON(json: any): EligibilityCheck {
    return EligibilityCheckFromJSONTyped(json, false);
}

export function EligibilityCheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityCheck {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'check_id': json['check_id'],
        'date_executed': (new Date(json['date_executed'])),
        'user_id': json['user_id'],
        'user_name': json['user_name'],
        'lead_id': json['lead_id'],
        'request_object': EligibilityCheckRequestObjectFromJSON(json['request_object']),
        'eligibility_view_model': !exists(json, 'eligibility_view_model') ? undefined : ExacareEligibilityResponseFromJSON(json['eligibility_view_model']),
        'coverage_priority': json['coverage_priority'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'routing_reason': !exists(json, 'routing_reason') ? undefined : EligibilityRoutingReasonFromJSON(json['routing_reason']),
        'stedi_payer': !exists(json, 'stedi_payer') ? undefined : StediPayerFromJSON(json['stedi_payer']),
        'member_identifier_type': !exists(json, 'member_identifier_type') ? undefined : json['member_identifier_type'],
        'report_s3_key': !exists(json, 'report_s3_key') ? undefined : json['report_s3_key'],
        'pdf_generation_status': !exists(json, 'pdf_generation_status') ? undefined : json['pdf_generation_status'],
    };
}

export function EligibilityCheckToJSON(value?: EligibilityCheck | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'check_id': value.check_id,
        'date_executed': (value.date_executed.toISOString()),
        'user_id': value.user_id,
        'user_name': value.user_name,
        'lead_id': value.lead_id,
        'request_object': EligibilityCheckRequestObjectToJSON(value.request_object),
        'eligibility_view_model': ExacareEligibilityResponseToJSON(value.eligibility_view_model),
        'coverage_priority': value.coverage_priority,
        'provider': value.provider,
        'routing_reason': EligibilityRoutingReasonToJSON(value.routing_reason),
        'stedi_payer': StediPayerToJSON(value.stedi_payer),
        'member_identifier_type': value.member_identifier_type,
        'report_s3_key': value.report_s3_key,
        'pdf_generation_status': value.pdf_generation_status,
    };
}

